import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import { optionsShift, optionsSubject, optionssection, optionssession, roledrp } from '../../Helper'
import moment from 'moment'

import { menumgmtApi,menumgmtmodelApi } from '../../../utils/AdminDashApi/MenuMgmtApi'
import { roleMgmtApi } from '../../../utils/AdminDashApi/RoleMgmtApi'
import { clsteacherAssignApi } from '../../../utils/AdminDashApi/ClassTeachAssignmentApi'
import { validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import MobileInputSubComp from './sub_components/MobileInputSubComp'

const ClassTeacherAssignmentCompmb = () => {

    const [activefrommod1,setactivefrommod1] = useState("")
    const [borderactivefrommod1,setborderactivefrommod1] = useState("")
    const [labelactivefrommod1,setlabelactivefrommod1] = useState("")
   
    const [activetomod1,setactivetomod1] = useState("")
    const [borderactivetomod1,setborderactivetomod1] = useState("")
    const [labelactivetomod1,setlabelactivetomod1] = useState("")

    const [activefrommod2,setactivefrommod2] = useState("")
    const [borderactivefrommod2,setborderactivefrommod2] = useState("")
    const [labelactivefrommod2,setlabelactivefrommod2] = useState("")
   
    const [activetomod2,setactivetomod2] = useState("")
    const [borderactivetomod2,setborderactivetomod2] = useState("")
    const [labelactivetomod2,setlabelactivetomod2] = useState("")

  const [activeto,setactiveTo] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")

  const [sessionmod1,setsessionmod1] = useState("")
  const [bordersessionmod1,setbordersessionmod1] = useState("")
  const [labelsessionmod1,setlabelsessionmod1] = useState("")

  const [teachermod1,setteachermod1] = useState("")
  const [borderteachermod1,setborderteachermod1] = useState("")
  const [labelteachermod1,setlabelteachermod1] = useState("")
  
  const [classmod1,setclassmod1] = useState("")
  const [borderclassmod1,setborderclassmod1] = useState("")
  const [labelclassmod1,setlabelclassmod1] = useState("")

  const [sectionmod1,setsectionmod1] = useState("")
  const [bordersectionmod1,setbordersectionmod1] = useState("")
  const [labelsectionmod1,setlabelsectionmod1] = useState("")

  const [shiftmod1,setshiftmod1] = useState("")
  const [labelshiftmod1,setlabelshiftmod1] = useState("")
  const [bordershiftmod1,setbordershiftmod1] = useState("")

  const [exammod1,setexammod1] = useState("")
  const [borderexammod1,setborderexammod1] = useState("")
  const [labelexammod1,setlabelexammod1] = useState("")

  const [subjectmod1,setsubjectmod1] = useState("")
  const [bordersubjectmod1,setbordersubjectmod1] = useState("")
  const [labelsubjectmod1,setlabelsubjectmod1] = useState("")

  const [subgroupmod1,setsubgroupmod1] = useState("")
  const [bordersubgroupmod1,setbordersubgroupmod1] = useState("")
  const [labelsubgroupmod1,setlabelsubgroupmod1] = useState("")

    const [sessionmod2,setsessionmod2] = useState("")
  const [bordersessionmod2,setbordersessionmod2] = useState("")
  const [labelsessionmod2,setlabelsessionmod2] = useState("")

  const [teachermod2,setteachermod2] = useState("")
  const [borderteachermod2,setborderteachermod2] = useState("")
  const [labelteachermod2,setlabelteachermod2] = useState("")
  
  const [classmod2,setclassmod2] = useState("")
  const [borderclassmod2,setborderclassmod2] = useState("")
  const [labelclassmod2,setlabelclassmod2] = useState("")

  const [sectionmod2,setsectionmod2] = useState("")
  const [bordersectionmod2,setbordersectionmod2] = useState("")
  const [labelsectionmod2,setlabelsectionmod2] = useState("")

  const [shiftmod2,setshiftmod2] = useState("")
  const [labelshiftmod2,setlabelshiftmod2] = useState("")
  const [bordershiftmod2,setbordershiftmod2] = useState("")

  const [exammod2,setexammod2] = useState("")
  const [borderexammod2,setborderexammod2] = useState("")
  const [labelexammod2,setlabelexammod2] = useState("")

  const [subjectmod2,setsubjectmod2] = useState("")
  const [bordersubjectmod2,setbordersubjectmod2] = useState("")
  const [labelsubjectmod2,setlabelsubjectmod2] = useState("")

  const [subgroupmod2,setsubgroupmod2] = useState("")
  const [bordersubgroupmod2,setbordersubgroupmod2] = useState("")
  const [labelsubgroupmod2,setlabelsubgroupmod2] = useState("")

  const drpfuncsubgroupmod1=(myval,myid)=>{
    setsubgroupmod1(myval)
    }
  const drpfuncsubjectmod1=(myval,myid)=>{
    setsubjectmod1(myval)
    }
  const drpfuncexammod1=(myval,myid)=>{
    setexammod1(myval)
    }
  const drpfuncshiftmod1=(myval,myid)=>{
    setshiftmod1(myval)
    }
  
  const drpfuncsectionmod1=(myval,myid)=>{
      setsectionmod1(myval)
  }
  const drpfuncclassmod1=(myval,myid)=>{
      setclassmod1(myval)
  }
  const drpfuncsessionmod1=(myval,meyid)=>{
    setsessionmod1(myval)
  }
  const drpfuncteachermod1=(myval,meyid)=>{
    setteachermod1(myval)
  }

  const drpfuncsubgroupmod2=(myval,myid)=>{
    setsubgroupmod2(myval)
    }
  const drpfuncsubjectmod2=(myval,myid)=>{
    setsubjectmod2(myval)
    }
  const drpfuncexammod2=(myval,myid)=>{
    setexammod2(myval)
    }
  const drpfuncshiftmod2=(myval,myid)=>{
    setshiftmod2(myval)
    }
  
  const drpfuncsectionmod2=(myval,myid)=>{
      setsectionmod2(myval)
  }
  const drpfuncclassmod2=(myval,myid)=>{
      setclassmod2(myval)
  }
  const drpfuncsessionmod2=(myval,meyid)=>{
    setsessionmod2(myval)
  }
  const drpfuncteachermod2=(myval,meyid)=>{
    setteachermod2(myval)
  }

  const handleSavemod1=()=>{
    validationDrp(sessionmod1,setlabelsessionmod1,setbordersessionmod1,"Session Required")
    validationDrp(teachermod1,setlabelteachermod1,setborderteachermod1,"Teacher Required")
    validationDrp(classmod1,setlabelclassmod1,setborderclassmod1,"Class Required")
    validationDrp(sectionmod1,setlabelsectionmod1,setbordersectionmod1,"Section Required")
    validationDrp(shiftmod1,setlabelshiftmod1,setbordershiftmod1,"Shift Required")
    validationDrp(exammod1,setlabelexammod1,setborderexammod1,"Exam Required")
    validationDrp(subjectmod1,setlabelsubjectmod1,setbordersubjectmod1,"Subject Required")
    validationDrp(subgroupmod1,setlabelsubgroupmod1,setbordersubgroupmod1,"Subgroup Required")
    validationDrp(activefrommod1,setlabelactivefrommod1,setborderactivefrommod1,"Active From Required")
    validationDrp(activetomod1,setlabelactivetomod1,setborderactivetomod1,"Active To Required")
  }

  const handleSavemod2=()=>{
    validationDrp(sessionmod2,setlabelsessionmod2,setbordersessionmod2,"Session Required")
    validationDrp(teachermod2,setlabelteachermod2,setborderteachermod2,"Teacher Required")
    validationDrp(classmod2,setlabelclassmod2,setborderclassmod2,"Class Required")
    validationDrp(sectionmod2,setlabelsectionmod2,setbordersectionmod2,"Section Required")
    validationDrp(shiftmod2,setlabelshiftmod2,setbordershiftmod2,"Shift Required")
    validationDrp(exammod2,setlabelexammod2,setborderexammod2,"Exam Required")
    validationDrp(subjectmod2,setlabelsubjectmod2,setbordersubjectmod2,"Subject Required")
    validationDrp(subgroupmod2,setlabelsubgroupmod2,setbordersubgroupmod2,"Subgroup Required")
    validationDrp(activefrommod2,setlabelactivefrommod2,setborderactivefrommod2,"Active From Required")
    validationDrp(activetomod2,setlabelactivetomod2,setborderactivetomod2,"Active To Required")
  }

  
 
  const [examDrp,setExamdrp] = useState("")
  const handleShow = () => setShow2(true);
  const optionsExam = [
    {
      id:0,
      opt:"All"
    },
    {
      id:1,
      opt:"1st Semester"
    },
    {
      id:2,
      opt:"2nd Semester"
    },
    {
      id:3,
      opt:"1st Semester Assessment"
    },
    {
      id:4,
      opt:"2nd Semester Assessment"
    },
  ]

 const optionsClass = [
    {   id:1,
        opt:'Select Class'
    },
    {   id:2,
        opt:'Starter'
    },
    {   id:3,
        opt:'Playgroup'
    },
    {   id:3,
        opt:'Nursery'
    },
    {   id:4,
        opt:'Junior KG'
    },
    {   id:5,
        opt:'Senior KG'
    },
    {   id:6,
        opt:'Class 1'
    },
    {   id:7,
        opt:'Class 2'
    },
    {   id:8,
        opt:'Class 3'
    },
    {
        id:9,
        opt:'Class 4'
    },
    {
        id:10,
        opt:'Class 5'
    },
    {
        id:11,
        opt:'Class 6'
    },
    {
        id:12,
        opt:'Class 7'
    },
    {
        id:13,
        opt:'O Level'
    },
    {
        id:14,
        opt:'A Level'
    },
    {
        id:15,
        opt:'Pre- O level'
    },
  
  ];
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }


  useEffect(()=>{
    var date = moment("2017-07-11")
      var now = moment("2020-07-12");

      if (now > date) {
        console.log("past")
      } else {
        console.log("future")
      }
  },[])
  const [classdrp,setClassdrp] = useState("")
  const drpfuncExam=(myroleval,myid)=>{
    setExamdrp(myroleval)    
  }
  const drpfuncClass=(myval,myid)=>{
    setClassdrp(myval)    
  }
    
  

   

    const [show3, setShow3] = useState(false);
    const [modalitem,setmodalitem] = useState(null)
    const handleShow3 = (e,myitem) =>{
      setShow3(true)
      setmodalitem(myitem)
      setrolemodalvalue2(myitem.rolename)
      console.log(rolemodalvalue2)
    };
    const handleClosemenumodal= ()=>{
      setShow3(false)
    }
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(clsteacherAssignApi.data)



  // const mainfilteractivefrom=(activefrom,arr)=>{    
  //   let blankarr =[]
  //   arr.map((item,key)=>{
    
  //       if(item.activefrom==activefrom){
                  
  //         blankarr.push(item)
  //       }
  //     })
  //     setfilteredArr(blankarr)
      
    
  // }


  //===============
  // let blankarr =[]
    // arr.map((item,key)=>{
    //     if(item.rolename.toLowerCase()==myrole.toLowerCase()){
    //       blankarr.push(item)
    //     }
    
       
    //     if(item.menuname.toLowerCase().includes(searchkey.toLowerCase())){
                  
    //       blankarr.push(item)
    //     }
    //   })
      
    //     setfilteredArr(blankarr)
  //================
//   const [flag,setflag] = useState(false)
  const mainfilter=(arr)=>{    
    
setfilteredArr(arr);
    
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])
  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show?show:10)
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % clsteacherAssignApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
      const handleClose=()=>{
        setShow2(false)
      }
      const [rolemodalvalue,setrolemodalvalue] = useState("")
      const [rolemodalvalue2,setrolemodalvalue2] = useState("")
      const drpfuncrolemodal=(myid,mystatus)=>{
        setrolemodalvalue(mystatus)
        
          
      }
     
    
    

    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
    const handleModaleditsave=()=>{
      console.log(rolemodalvalue2)
      setShow3(false)
    }

   
   
    // useEffect(()=>{
    //   if(roleDrp){
    //     mainfilterrole(roleDrp,filteredArr)  

    //   }
      
    // },[roleDrp])

    // useEffect(()=>{
    //   if(activefrom){

    //     mainfilteractivefrom(activefrom,filteredArr)
    //   }
    // },[activefrom])
    
    const handleActiveFrommod1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrommod1(dtfinalc)
        }
        
        
    }
    const handleActiveFrommod2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrommod2(dtfinalc)
        }
        
        
    }
    const handleActiveTomod2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivetomod2(dtfinalc)
        }
        
        
    }
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo(dtfinalc)

            
        }
        
        
    }
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Class Teacher Assignment</h3>
                </div>
                <div className="admbwrap pb0">
                    <Row>
                        <Col xs={12} className="mb-2">
                        <button style={{height:"35px"}} className='cmbutton' onClick={handleShow}> <AiOutlinePlus /> Assign Subject</button>
                        </Col>
                        <MobileInputSubComp col="6" direct="left" name="Exam">
                            <div className="dropdownwrapper">
                            <Dropdown2 func={drpfuncExam} myplaceholder="Select Exam" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsExam} />
                            </div>
                        </MobileInputSubComp>
                        <MobileInputSubComp col="6" direct="right" name="Class">
                            <div className="dropdownwrapper">
                            <Dropdown2 func={drpfuncClass} myplaceholder="Select Class" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                            </div>
                        </MobileInputSubComp>
                        <MobileInputSubComp col="6" direct="left" name="Section">
                            <div className="dropdownwrapper">
                                <Dropdown2 func={drpfuncExam} myplaceholder="Select Section" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsExam} />
                            </div>
                        </MobileInputSubComp>
                    </Row>
                </div>
                <div className="admbwrap pb0">
                <Row>
                              
                    <MobileInputSubComp col="4" direct="left" name="Show">

                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                      </div>
                    </MobileInputSubComp>
                    <MobileInputSubComp col="8" direct="right" name="Search">
                        <div className="wrap">
                        <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                        <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />
                        </div>
                    </MobileInputSubComp>

                  </Row>
                </div>
                <div className="admbwrap">
                    <div className="tablewrapscroll">
                    <div className="flexvaluetable">
                    <table>
                      <thead>
                        <tr>
                            {
                              clsteacherAssignApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.class}</td>
                                  <td>{item.section}</td>
                                  <td>{item.subject}</td>
                                  <td>{item.subgroup}</td>
                                  <td>{item.event}</td>
                                  <td>{item.teacher}</td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            
                             currentItems.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.class}</td>
                                  <td>{item.section}</td>
                                  <td>{item.subject}</td>
                                  <td>{item.subgroup}</td>
                                  <td>{item.event}</td>
                                  <td>{item.teacher}</td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                    </div>                    
                </div>
                <div className="admbwrap">
                <Row>
                <Col lg={12} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={2}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {clsteacherAssignApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div>
                <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Subject Assignment To Teacher</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                        <MobileInputSubComp col="6" direct="left" name="Session">
                            <div className="dropdownwrapper">
                       <Dropdown2 err={bordersessionmod1=="err"?"err":""} func={drpfuncsessionmod1} myplaceholder={sessionmod1} fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionssession}/>
                           </div>
                          <label>{labelsessionmod1}</label>
                        </MobileInputSubComp>
                        
                         <MobileInputSubComp col="6" direct="right" name="Teacher">
                          <div className="dropdownwrapper">
                            
                              <Dropdown2 err={borderteachermod1=="err"?"err":""} func={drpfuncteachermod1} myplaceholder={teachermod1} fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionssession}/>
                          </div>
                          <label>{labelteachermod1}</label>
                           </MobileInputSubComp>
                      
                          <MobileInputSubComp col="6" direct="left" name="Class">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={borderclassmod1 === "err" ? "err" : ""} func={drpfuncclassmod1} myplaceholder={classmod1} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                </div>
                                <label>{labelclassmod1}</label>
                           </MobileInputSubComp>
                            <MobileInputSubComp col="6" direct="right" name="Section">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={bordersectionmod1 === "err" ? "err" : ""} func={drpfuncsectionmod1} myplaceholder={sectionmod1} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                </div>
                                <label>{labelsectionmod1}</label>
                              </MobileInputSubComp>
                             <MobileInputSubComp col="6" direct="left" name="Shift">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={bordershiftmod1 == "err" ? "err" : ""} func={drpfuncshiftmod1} myplaceholder={shiftmod1} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                              </div>
                              <label>{labelshiftmod1}</label>
                           </MobileInputSubComp>
                       <MobileInputSubComp col="6" direct="right" name="Exam">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={borderexammod1 == "err" ? "err" : ""} func={drpfuncexammod1} myplaceholder={exammod1} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                              </div>
                              <label>{labelexammod1}</label>
                           </MobileInputSubComp>
                        <MobileInputSubComp col="6" direct="left" name="Subject">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={bordersubjectmod1 == "err" ? "err" : ""} func={drpfuncsubjectmod1} myplaceholder={subjectmod1} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubject} />
                              </div>
                              <label>{labelsubjectmod1}</label>
                            </MobileInputSubComp>
                         <MobileInputSubComp col="6" direct="right" name="Subgroup (Best Count)">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={bordersubgroupmod1 == "err" ? "err" : ""} func={drpfuncsubgroupmod1} myplaceholder={subgroupmod1} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubject} />
                              </div>
                              <label>{labelsubgroupmod1}</label>
                            </MobileInputSubComp>
                        
                    <MobileInputSubComp col="6" direct="left" name="Active From">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activefrommod1}
                          onChange={(newvaldob)=>handleActiveFrommod1(newvaldob)}
                          renderInput={(params) => <TextField style={borderactivefrommod1=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From"
                            }} error={false} />}
                      />
                      <label>{labelactivefrommod1}</label>
                    </LocalizationProvider>
                   </MobileInputSubComp>
               <MobileInputSubComp col="6" direct="right" name="Active To">

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activetomod1}
                          onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                          renderInput={(params) => <TextField style={borderactivetomod1=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active To"
                            }} error={false} />}
                      />
                       <label>{labelactivetomod1}</label>
                    </LocalizationProvider>
                    </MobileInputSubComp>
                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handleSavemod1}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>


              <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClosemenumodal} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Menu Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                        <MobileInputSubComp col="6" direct="left" name="Session">
                            <div className="dropdownwrapper">
                       <Dropdown2 err={bordersessionmod2=="err"?"err":""} func={drpfuncsessionmod2} myplaceholder={sessionmod2} fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionssession}/>
                           </div>
                          <label>{labelsessionmod2}</label>
                        </MobileInputSubComp>
                        
                         <MobileInputSubComp col="6" direct="right" name="Teacher">
                          <div className="dropdownwrapper">
                            
                              <Dropdown2 err={borderteachermod2=="err"?"err":""} func={drpfuncteachermod2} myplaceholder={teachermod2} fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionssession}/>
                          </div>
                          <label>{labelteachermod2}</label>
                           </MobileInputSubComp>
                      
                          <MobileInputSubComp col="6" direct="left" name="Class">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={borderclassmod2 === "err" ? "err" : ""} func={drpfuncclassmod2} myplaceholder={classmod2} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                </div>
                                <label>{labelclassmod2}</label>
                           </MobileInputSubComp>
                            <MobileInputSubComp col="6" direct="right" name="Section">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={bordersectionmod2 === "err" ? "err" : ""} func={drpfuncsectionmod2} myplaceholder={sectionmod2} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                </div>
                                <label>{labelsectionmod2}</label>
                              </MobileInputSubComp>
                             <MobileInputSubComp col="6" direct="left" name="Shift">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={bordershiftmod2 == "err" ? "err" : ""} func={drpfuncshiftmod2} myplaceholder={shiftmod2} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                              </div>
                              <label>{labelshiftmod2}</label>
                           </MobileInputSubComp>
                       <MobileInputSubComp col="6" direct="right" name="Exam">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={borderexammod2 == "err" ? "err" : ""} func={drpfuncexammod2} myplaceholder={exammod2} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                              </div>
                              <label>{labelexammod2}</label>
                           </MobileInputSubComp>
                        <MobileInputSubComp col="6" direct="left" name="Subject">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={bordersubjectmod2 == "err" ? "err" : ""} func={drpfuncsubjectmod2} myplaceholder={subjectmod2} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubject} />
                              </div>
                              <label>{labelsubjectmod2}</label>
                            </MobileInputSubComp>
                         <MobileInputSubComp col="6" direct="right" name="Subgroup (Best Count)">
                              <div className="dropdownwrapper">

                                <Dropdown2 err={bordersubgroupmod2 == "err" ? "err" : ""} func={drpfuncsubgroupmod2} myplaceholder={subgroupmod2} fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubject} />
                              </div>
                              <label>{labelsubgroupmod2}</label>
                            </MobileInputSubComp>
                        
                    <MobileInputSubComp col="6" direct="left" name="Active From">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activefrommod2}
                          onChange={(newvaldob)=>handleActiveFrommod2(newvaldob)}
                          renderInput={(params) => <TextField style={borderactivefrommod2=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From"
                            }} error={false} />}
                      />
                      <label>{labelactivefrommod2}</label>
                    </LocalizationProvider>
                   </MobileInputSubComp>
               <MobileInputSubComp col="6" direct="right" name="Active To">

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activetomod2}
                          onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                          renderInput={(params) => <TextField style={borderactivetomod2=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active To"
                            }} error={false} />}
                      />
                       <label>{labelactivetomod2}</label>
                    </LocalizationProvider>
                    </MobileInputSubComp>
                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handleSavemod2}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
        </div>
    </div>
    </>
  )
}

export default ClassTeacherAssignmentCompmb